var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CuiBaseComponent } from '@cicero/webui/lib/core/shared/base-component';
import { EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ReservationService } from '../shared/reservation.service';
var ReservationDialogComponent = /** @class */ (function (_super) {
    __extends(ReservationDialogComponent, _super);
    function ReservationDialogComponent(reservation, dialogRef, reservationService, dialog) {
        var _this = _super.call(this) || this;
        _this.reservation = reservation;
        _this.dialogRef = dialogRef;
        _this.reservationService = reservationService;
        _this.dialog = dialog;
        _this.reservationStateChange = new EventEmitter();
        _this.outstandingTasks = false;
        return _this;
    }
    ReservationDialogComponent.prototype.close = function () {
        this.dialogRef.close();
        if (!this.outstandingTasks) {
            this.complete();
        }
    };
    ReservationDialogComponent.prototype.markNotFound = function () {
        var _this = this;
        this.outstandingTasks = true;
        this.reservationService.markNotFound(this.reservation)
            .subscribe(null, function () { return _this.reservationStateChange.emit(); }, function () { return _this.complete(); });
        this.reservationStateChange.emit();
        this.close();
    };
    ReservationDialogComponent.prototype.markSkipped = function () {
        this.reservationService.markSkipped(this.reservation);
        this.reservationStateChange.emit();
        this.close();
    };
    ReservationDialogComponent.prototype.markFound = function () {
        this.reservationService.markFound(this.reservation).subscribe();
        this.reservationStateChange.emit();
        this.close();
    };
    ReservationDialogComponent.prototype.undo = function () {
        this.reservationService.undo(this.reservation).subscribe();
        this.reservationStateChange.emit();
    };
    ReservationDialogComponent.prototype.complete = function () {
        this.outstandingTasks = false;
        this.reservationStateChange.complete();
    };
    return ReservationDialogComponent;
}(CuiBaseComponent));
export { ReservationDialogComponent };



// WEBPACK FOOTER //
// ./src/app/pick-up-list/reservation-dialog/reservation-dialog.component.ts.pre-build-optimizer.js